import React, { useState } from 'react';
import { Screen } from '../App';
import { isTrialExpired } from '../storage';
import * as authApi from '../authApi';
import PasswordInput from '../components/PasswordInput';

interface Props { navigate: (s: Screen) => void; refreshUser: () => Promise<any>; }

export default function Login({ navigate, refreshUser }: Props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await authApi.login(email, password);
      await authApi.migrateLocalData();
      await refreshUser();
      navigate(isTrialExpired(user) ? 'paywall' : 'dashboard');
    } catch (err: any) {
      setError(err?.message || 'Incorrect email or password.');
      setLoading(false);
    }
  };

  return (
    <div className="page-content" style={{paddingTop:40}}>
      <button onClick={()=>navigate('landing')} style={{background:'none',color:'var(--teal)',fontSize:14,marginBottom:24,display:'flex',alignItems:'center',gap:6}}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><polyline points="15,18 9,12 15,6"/></svg>Back
      </button>
      <div style={{textAlign:'center',marginBottom:32}}>
        <h1 style={{fontSize:28,marginBottom:8}}>Welcome back</h1>
        <p style={{color:'var(--text-secondary)',fontSize:14}}>Your students and data are waiting for you.</p>
      </div>
      <form onSubmit={handle}>
        <div className="form-group"><label>Email</label><input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="your@email.com"/></div>
        <div className="form-group"><label>Password</label><PasswordInput value={password} onChange={e=>setPassword(e.target.value)} placeholder="Your password" autoComplete="current-password"/></div>
        {error&&<div style={{background:'var(--coral-light)',color:'var(--coral)',padding:'12px 16px',borderRadius:8,fontSize:14,marginBottom:16}}>{error}</div>}
        <button type="submit" className="btn-primary" disabled={loading}>{loading?'Logging in...':'Log In'}</button>
        <p style={{textAlign:'center',fontSize:13,marginTop:16}}>
          <span onClick={()=>navigate('forgot')} style={{color:'var(--teal)',fontWeight:600,cursor:'pointer'}}>Forgot your password?</span>
        </p>
        <p style={{textAlign:'center',fontSize:13,color:'var(--text-secondary)',marginTop:8}}>No account? <span onClick={()=>navigate('signup')} style={{color:'var(--teal)',fontWeight:600,cursor:'pointer'}}>Start free trial</span></p>
      </form>
    </div>
  );
}
